var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6152 2.59565L18.1784 0.0390625L8.0332 5.90974L15.2701 9.77844L22.6152 2.59565Z",
    fill: "#019DF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0546875 23.8066L-0.0411605 31.6928L8.99482 36.9007L8.64312 26.255L-0.0546875 23.8066Z",
    fill: "#06BF97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4684 17.3672L26.2285 23.7384L29.2991 35.8044L36.4819 31.6516L36.4684 17.3672Z",
    fill: "#FCD300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3613 37.686L18.234 42.2175L29.1096 35.9139L18.1528 30.0703L10.3613 37.686Z",
    fill: "#8EEA36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04481 7.65625L-0.0683594 10.6051L-0.0548324 20.615L7.19559 16.097L5.04481 7.65625Z",
    fill: "#FF8A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4533 16.8817V10.5646L24.4414 3.65234L24.7796 13.5946L36.4533 16.8817Z",
    fill: "#BEAAF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcons);
export default __webpack_public_path__ + "static/media/logo-icons.9aa0c6dd0af217e60014e7dbacf25b1c.svg";
export { ForwardRef as ReactComponent };